export default __webpack_public_path__ + "assets/thunderstorms-night-rain.3a065a9f.svg";